import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './StatementsSummary.css';

const ReportForm = () => {
  const [formData, setFormData] = useState({
    tags: [],
    statement_date: '2026-07-31',
    format: 'screen',
  });

  const handleChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    if (type === 'select-multiple') {
      const selectedOptions = Array.from(options)
        .filter(option => option.selected)
        .map(option => option.value);

      setFormData(prevState => ({
        ...prevState,
        [name]: selectedOptions
      }));
    } else if (type === 'checkbox') {
      setFormData(prevState => ({
        ...prevState,
        [name]: checked
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="ss-wrap">
      <div className="ss-desc">How much was owed at the time of statement?</div>

      <div className="ss-box">
        <h2 className="ss-title">Parameters</h2>

        <form onSubmit={handleSubmit} className="ss-panel">
          {/* Account Tags Selection */}
          <div className="ss-row">
            <label className="ss-label" htmlFor="tags" title="Select tags to filter report">
              Account Tags
            </label>
            <div className="ss-field">
              <select
                id="tags"
                name="tags"
                value={formData.tags}
                onChange={handleChange}
                className="ss-select"
              >
                <option value="">No filter</option>
                <option value="a-practices">a-practices</option>
                <option value="bhandal">bhandal</option>
                <option value="coventry-dental">coventry-dental</option>
                <option value="dental-beauty">dental-beauty</option>
                <option value="murray-dental-">murray-dental-</option>
                <option value="swissmeda">swissmeda</option>
              </select>
            </div>
          </div>

          {/* Statement Date Selection */}
          <div className="ss-row">
            <label className="ss-label" htmlFor="statement_date" title="Please choose a statement date">
              Statements
            </label>
            <div className="ss-field">
              <select
                id="statement_date"
                name="statement_date"
                value={formData.statement_date}
                onChange={handleChange}
                className="ss-select"
              >
                <option value="2026-07-31">Jul 31, 2026</option>
                <option value="2026-07-30">Jul 30, 2026</option>
                <option value="2026-07-29">Jul 29, 2026</option>
                <option value="2026-07-01">Jul 1, 2026</option>
              </select>
            </div>
          </div>

          {/* Format Selection */}
          <div className="ss-row">
            <label className="ss-label" htmlFor="format" title="Please choose a display format">
              Format <span className="ss-req">*</span>
            </label>
            <div className="ss-field">
              <select
                id="format"
                name="format"
                value={formData.format}
                onChange={handleChange}
                required
                className="ss-select"
              >
                <option value="screen">On Screen</option>
                <option value="csv">CSV (Excel)</option>
              </select>
            </div>
          </div>

          {/* Run Button */}
          <div className="ss-row ss-row-run">
            <Link to="/Addstatement" className="ss-link">
              <button id="pay-per-task-submit" type="button" className="ss-run">
                <FaSearch /> Run
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportForm;